module.exports = __webpack_public_path__ + "img/download.b377d212.svg";